/** Shared lead copy for wizard steps — matches album Create / View typography */
import React from 'react'
import { Typography } from '@mui/material'

export function StepLead({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      sx={{
        fontSize: 15,
        color: 'var(--ds-ink-muted)',
        lineHeight: 1.5,
        mb: 3,
        maxWidth: 480,
      }}
    >
      {children}
    </Typography>
  )
}

export function StepHint({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      sx={{
        fontSize: 12,
        color: 'var(--ds-ink-muted)',
        mt: 2.5,
        lineHeight: 1.4,
      }}
    >
      {children}
    </Typography>
  )
}

export function FieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      sx={{
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--ds-ink-muted)',
        mb: 1,
        letterSpacing: '-0.01em',
      }}
    >
      {children}
    </Typography>
  )
}
